import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChatAdapter, Window } from 'ng-chat';

import { UscStoreService } from '../../../services/usc-store/usc-store.service';

@Component({
  selector: 'sn-usc-chat-template-dlg',
  templateUrl: './usc-chat-template-dlg.component.html',
  styleUrls: ['./usc-chat-template-dlg.component.css']
})
export class UscChatTemplateDlgComponent implements OnInit {
  @Input() data:any;    // this is the view item from the chat window that launched this dlg
  @Input() chat_window:Window;
  @Input() chat_adapter:ChatAdapter;

  lockedTemplates:any[];
  editableTemplates:any[];

  allTemplates:any[];
  currentTemplate:any;
  smsContent:string = "";

  // input_properties:any;

  constructor(
    public activeModal: NgbActiveModal,
    public uscStoreService: UscStoreService
  ) { }

  ngOnInit() {
    var category = this.data.co_type;
    var templates = this.uscStoreService.getSmsTemplates(this.data.cfd_lp);
    // this.input_properties = { data: this.data, window: this.chat_window, adapter: this.chat_adapter }
    this.uscStoreService.translateSmsTemplates("deal", this.data.dl_ID, templates).subscribe(
      result => {
        this.allTemplates = result;
        if (result && result.length > 0) {
          this.onTemplateSelected(result[0]);
        }
      }
    );
  }

  sendSms() {
    this.activeModal.close({ chat_window: this.chat_window, chat_adapter: this.chat_adapter, sms:this.smsContent });
  }

  isTemplateReadOnly() {
    return this.currentTemplate ? this.currentTemplate.is_body_html == "Y" : false;
  }

  onTemplateSelected(template) {
    this.currentTemplate = template;
    this.smsContent = this.currentTemplate.email_body;
    this.validateMessage();
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  isMessageValid:boolean = true;
  validateMessage() {
    if (this.uscStoreService.isCensorshipEnabled()) {
      this.isMessageValid = this.uscStoreService.isSmsSafe(this.smsContent);
    }
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-chat-template-dlg/usc-chat-template-dlg.component.ts